import React, { Component } from 'react';
import { Link, withRouter } from 'react-router-dom';
import { Form, Icon, Input, Button, Row, Col, Divider, notification } from 'antd';
import * as formUtils from 'utils/formUtils';

const
{ FORM } = formUtils,
{ USER_ID, PASSWORD } = FORM.TYPES,
FormItem = Form.Item;

export default withRouter(Form.create()(
    class LoginForm extends Component {
        constructor(props) {
            super(props);
            this.getProps = {};

            for(var p in formUtils.getProps.login)
                this.getProps[p] = formUtils.getProps.login[p].bind(this);

            this.getComponentState = formUtils.getComponentState.bind(this);
            this.setFieldState = formUtils.setFieldState.bind(this);
            this.onUpdate = formUtils.onUpdate.bind(this);
            this.setField = formUtils.setField.bind(this);
            this.state = formUtils.getComponentState();
        }

        render() {
            const
            { state, controls } = this.props,
            { changeModal } = controls,
            { username, password } = this.getProps;

            return (
                <div>
                    <Form>
                        <Row>
                            <Col>
                                <FormItem {...state[USER_ID].form} style={{ marginBottom: '16px' }}>
                                    <Input
                                        id='Login-LoginForm-UserID'
                                        {...username(
                                            USER_ID,
                                            'User ID',
                                            (<Icon type='user' style={{ color: 'rgba(0,0,0,.75)' }} />)
                                        )}
                                    />
                                </FormItem>
                            </Col>
                        </Row>
                        <Row>
                            <Col>
                                <FormItem {...state[PASSWORD].form}>
                                    <Input
                                        id='Login-LoginForm-Password'
                                        {...password(
                                            PASSWORD,
                                            'Password',
                                            (<Icon type='lock' style={{ color: 'rgba(0,0,0,.75)' }} />)
                                        )}
                                    />
                                </FormItem>
                            </Col>
                        </Row>
                        <Row>
                            <Col>
                                <FormItem style={{ marginTop: '-12px', marginBottom: '-60px' }}>
                                    <a className="login-form-forgot" onClick={() => changeModal('forgot')}>
                                        <Icon type="question-circle-o" />
                                        {' Forgot User ID or password'}
                                    </a>
                                    <Divider type="vertical" />
                                    <Link to={HOME.CANDIDATE_REGISTRATION}><Icon type="user-add" />
                                        {' Register'}
                                    </Link>
                                </FormItem>
                            </Col>
                        </Row>
                    </Form>
                </div>
            )
        }
    }
));
